// React components
import { SvgChevronDownOutline } from './src/svg/chevron-down-outline/chevron-down-outline'
import { SvgExclamationCircle } from './src/svg/exclamation-circle/exclamation-circle'
// SVGs
import { SvgDebitCardFront } from './src/svg/debit-card-front/debit-card-front'
import SvgEvergreenLogo from './src/svg/evergreen_logo.svg'
import { SvgPasskeyAdded } from './src/svg/passkey-added/passkey-added'
// Webp images
import WebpBlueGradientSplashSrc from './src/webp/blue_gradient_splash.webp'
import WebpBlueOverviewSrc from './src/webp/blue_overview.webp'
import WebpBlueSplashSrc from './src/webp/blue_splash.webp'
import WebpCheckingAccountSmallSrc from './src/webp/checking_account_sm.webp'
import WebpClientServiceDesktopSrc from './src/webp/client_service_desktop.webp'
import WebpClientServiceMobileSrc from './src/webp/client_service_mobile.webp'
import WebpEvergreenWealthLogoSrc from './src/webp/evergreen_wealth_logo.webp'
import WebpGreenGradientSplashSrc from './src/webp/green_gradient_splash.webp'
import WebpGreenOverviewSrc from './src/webp/green_overview.webp'
import WebpGreenSplashSrc from './src/webp/green_splash.webp'
import WebpGreenTreasuriesDesktopSrc from './src/webp/green_treasuries_desktop.webp'
import WebpGreenTreasuriesMobileSrc from './src/webp/green_treasuries_mobile.webp'
import WebpLiquidTreasuriesHeaderSrc from './src/webp/liquid_treasuries_header.webp'
import WebpOrangeGradientSplashSrc from './src/webp/orange_gradient_splash.webp'
import WebpOrangeOverviewSrc from './src/webp/orange_overview.webp'
import WebpOrangeSplashSrc from './src/webp/orange_splash.webp'
import WebpPersonalPortfolioHeaderSrc from './src/webp/personal_portfolio_header.webp'
import WebpPersonalPortfolioSmallSrc from './src/webp/personal_portfolio_sm.webp'
import WebpPurpleOverviewSrc from './src/webp/purple_overview.webp'
import WebpPurpleSplashSrc from './src/webp/purple_splash.webp'
import WebpSavingsAccountSmallSrc from './src/webp/savings_account_sm.webp'
import WebpEgwBlackLogoSrc from './src/webp/egw_logo.webp'
// Images
import ImageDemoSrc from './src/images/demo-home-screen.jpg'

interface Img {
  src: string
}

const WebpBlueGradientSplash =
  typeof WebpBlueGradientSplashSrc === 'string' ? WebpBlueGradientSplashSrc : (WebpBlueGradientSplashSrc as Img).src
const WebpBlueSplash = typeof WebpBlueSplashSrc === 'string' ? WebpBlueSplashSrc : (WebpBlueSplashSrc as Img).src
const WebpCheckingAccountSmall =
  typeof WebpCheckingAccountSmallSrc === 'string'
    ? WebpCheckingAccountSmallSrc
    : (WebpCheckingAccountSmallSrc as Img).src
const WebpClientServiceDesktop =
  typeof WebpClientServiceDesktopSrc === 'string'
    ? WebpClientServiceDesktopSrc
    : (WebpClientServiceDesktopSrc as Img).src
const WebpClientServiceMobile =
  typeof WebpClientServiceMobileSrc === 'string' ? WebpClientServiceMobileSrc : (WebpClientServiceMobileSrc as Img).src
const WebpGreenGradientSplash =
  typeof WebpGreenGradientSplashSrc === 'string' ? WebpGreenGradientSplashSrc : (WebpGreenGradientSplashSrc as Img).src
const WebpGreenSplash = typeof WebpGreenSplashSrc === 'string' ? WebpGreenSplashSrc : (WebpGreenSplashSrc as Img).src
const WebpGreenTreasuriesDesktop =
  typeof WebpGreenTreasuriesDesktopSrc === 'string'
    ? WebpGreenTreasuriesDesktopSrc
    : (WebpGreenTreasuriesDesktopSrc as Img).src
const WebpGreenTreasuriesMobile =
  typeof WebpGreenTreasuriesMobileSrc === 'string'
    ? WebpGreenTreasuriesMobileSrc
    : (WebpGreenTreasuriesMobileSrc as Img).src
const WebpLiquidTreasuriesHeader =
  typeof WebpLiquidTreasuriesHeaderSrc === 'string'
    ? WebpLiquidTreasuriesHeaderSrc
    : (WebpLiquidTreasuriesHeaderSrc as Img).src
const WebpOrangeGradientSplash =
  typeof WebpOrangeGradientSplashSrc === 'string'
    ? WebpOrangeGradientSplashSrc
    : (WebpOrangeGradientSplashSrc as Img).src
const WebpOrangeSplash =
  typeof WebpOrangeSplashSrc === 'string' ? WebpOrangeSplashSrc : (WebpOrangeSplashSrc as Img).src
const WebpPersonalPortfolioHeader =
  typeof WebpPersonalPortfolioHeaderSrc === 'string'
    ? WebpPersonalPortfolioHeaderSrc
    : (WebpPersonalPortfolioHeaderSrc as Img).src
const WebpPersonalPortfolioSmall =
  typeof WebpPersonalPortfolioSmallSrc === 'string'
    ? WebpPersonalPortfolioSmallSrc
    : (WebpPersonalPortfolioSmallSrc as Img).src
const WebpPurpleSplash =
  typeof WebpPurpleSplashSrc === 'string' ? WebpPurpleSplashSrc : (WebpPurpleSplashSrc as Img).src
const WebpSavingsAccountSmall =
  typeof WebpSavingsAccountSmallSrc === 'string' ? WebpSavingsAccountSmallSrc : (WebpSavingsAccountSmallSrc as Img).src
const WebpEvergreenWealthLogo =
  typeof WebpEvergreenWealthLogoSrc === 'string' ? WebpEvergreenWealthLogoSrc : (WebpEvergreenWealthLogoSrc as Img).src
const WebpEgwBlackLogo =
  typeof WebpEgwBlackLogoSrc === 'string' ? WebpEgwBlackLogoSrc : (WebpEgwBlackLogoSrc as Img).src

const WebpGreenOverview =
  typeof WebpGreenOverviewSrc === 'string' ? WebpGreenOverviewSrc : (WebpGreenOverviewSrc as Img).src
const WebpBlueOverview =
  typeof WebpBlueOverviewSrc === 'string' ? WebpBlueOverviewSrc : (WebpBlueOverviewSrc as Img).src
const WebpOrangeOverview =
  typeof WebpOrangeOverviewSrc === 'string' ? WebpOrangeOverviewSrc : (WebpOrangeOverviewSrc as Img).src
const WebpPurpleOverview =
  typeof WebpPurpleOverviewSrc === 'string' ? WebpPurpleOverviewSrc : (WebpPurpleOverviewSrc as Img).src
const ImageDemoHomeScreen = typeof ImageDemoSrc === 'string' ? ImageDemoSrc : (ImageDemoSrc as Img).src

export {
  // React components
  SvgChevronDownOutline,
  SvgDebitCardFront,
  // React components
  // SVGs
  SvgEvergreenLogo,
  SvgPasskeyAdded,
  SvgExclamationCircle,
  WebpBlueGradientSplash,
  WebpBlueOverview,
  // Webp images
  WebpBlueSplash,
  WebpCheckingAccountSmall,
  WebpClientServiceDesktop,
  WebpClientServiceMobile,
  WebpEvergreenWealthLogo,
  WebpEgwBlackLogo,
  WebpGreenGradientSplash,
  WebpGreenOverview,
  WebpGreenSplash,
  WebpGreenTreasuriesDesktop,
  WebpGreenTreasuriesMobile,
  WebpLiquidTreasuriesHeader,
  WebpOrangeGradientSplash,
  WebpOrangeOverview,
  WebpOrangeSplash,
  WebpPersonalPortfolioHeader,
  WebpPersonalPortfolioSmall,
  WebpPurpleOverview,
  WebpPurpleSplash,
  WebpSavingsAccountSmall,
  ImageDemoHomeScreen,
}

export * from './src/components'
